'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flag = Flag;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Flag(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === undefined ? true : _ref$hidden;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-flag ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M0 0h2v16h-2v-16z' }),
    _react2.default.createElement('path', { fill: color, d: 'M10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5z' })
  );
}

Flag.propTypes = _bcPropTypes.iconShape;

exports.default = Flag;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Flag/Flag.js
// module id = 219
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15